import { NgModule } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialogModule } from '@angular/material/dialog';
import { FilterModule } from '@vendasta/va-filter2';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { PipelineTableFilterChipsComponent } from './pipeline-table-filter-chips.component';
import { FilterChipsModule } from '../../filters/filter-chips/filter-chips.module';
import { MatMenuModule } from '@angular/material/menu';
import { PIPELINE_TABLE_FILTER_CHIPS_CONFIG_TOKEN, PipelineTableFilterChipsConfig } from './tokens';
import {
  HAS_ACCESS_TO_ALL_ACCOUNTS_IN_MARKET_TOKEN,
  SALES_TEAM_SERVICE_TOKEN,
  SalesTeamServiceInterface,
} from '../tokens';

@NgModule({
  declarations: [PipelineTableFilterChipsComponent],
  exports: [PipelineTableFilterChipsComponent],
  imports: [CommonModule, FilterChipsModule, FilterModule, MatDialogModule, TranslateModule, MatMenuModule],
  providers: [
    {
      provide: HAS_ACCESS_TO_ALL_ACCOUNTS_IN_MARKET_TOKEN,
      deps: [PIPELINE_TABLE_FILTER_CHIPS_CONFIG_TOKEN],
      useFactory: hasAccessToAllAccountsInMarketFactory,
    },
    {
      provide: SALES_TEAM_SERVICE_TOKEN,
      deps: [PIPELINE_TABLE_FILTER_CHIPS_CONFIG_TOKEN],
      useFactory: salesTeamsServiceFactory,
    },
  ],
})
export class PipelineTableFilterChipsModule {}

function hasAccessToAllAccountsInMarketFactory(config: PipelineTableFilterChipsConfig): Observable<boolean> {
  return config.hasAccessToAllAccountsInMarket$;
}

function salesTeamsServiceFactory(config: PipelineTableFilterChipsConfig): SalesTeamServiceInterface {
  return config.salesTeamsService;
}
